import { SystemStyleObject } from '@chakra-ui/system'
import { ColorMode } from '@chakra-ui/react'

type TScrollbar = (props: {
  colorMode: ColorMode
  thumbColor: Record<ColorMode, string>
}) => SystemStyleObject

export const scrollbar: TScrollbar = ({ thumbColor, colorMode }) => {
  return {
    '::-webkit-scrollbar': {
      backgroundColor: 'transparent',
      width: '0.5rem',
    },
    '::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: thumbColor[colorMode],
      borderRadius: '0.5rem',
    },
    '::-webkit-scrollbar-button': { display: 'none' },
  }
}
